import React, { Component } from "react";
import PropTypes from "prop-types";
import { BlockPicker } from "react-color";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Trans } from "react-i18next";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import Typography from "@material-ui/core/Typography";
import { createMuiTheme } from "@material-ui/core/styles";

/**
 * Provides a Material UI dialog for users to select a primary and accent colour from
 * a list of Material colours.
 */
export class ColourPickerDialog extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  state = {
    primaryColour: this.props.theme.palette.primary.main,
    accentColour: this.props.theme.palette.secondary.main,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.theme !== this.props.theme) {
      this.setState({
        primaryColour: this.props.theme.palette.primary.main,
        accentColour: this.props.theme.palette.secondary.main,
      });
    }
  }

  render() {
    const colours = [
      "#F44336",
      "#E91E63",
      "#9C27B0",
      "#673ab7",
      "#3f51b5",
      "#2196f3",
      "#03a9f4",
      "#00bcd4",
      "#009688",
      "#4caf50",
      "#8bc34a",
      "#cddc39",
      "#ffeb3b",
      "#ffc107",
      "#ff9800",
      "#ff5722",
      "#795548",
      "#9e9e9e",
      "#607d8b",
    ];

    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.props.onClose}
          aria-labelledby="edit-title-dialog-title"
          aria-describedby="edit-title-dialog-description"
        >
          <DialogTitle id="edit-title-dialog-title">
            <Trans i18nKey="colour_picker_header" />
          </DialogTitle>
          <DialogContent id="edit-title-dialog-description">
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <div style={{ paddingRight: 50 }}>
                <Typography variant="subtitle1">
                  <Trans i18nKey="colour_picker_primary_colour" />
                </Typography>
                <BlockPicker
                  aria-label="primary-colour"
                  ariaLabel="primary-colour"
                  id="primary"
                  color={this.state.primaryColour}
                  colors={colours}
                  triangle="hide"
                  onChangeComplete={this.primaryColourSelected}
                />
              </div>
              <div>
                <Typography variant="subtitle1">
                  <Trans i18nKey="colour_picker_accent_colour" />
                </Typography>
                <BlockPicker
                  aria-label="accent-colour"
                  ariaLabel="accent-colour"
                  id="accent"
                  color={this.state.accentColour}
                  colors={colours}
                  triangle="hide"
                  onChangeComplete={this.accentColourSelected}
                />
              </div>
            </div>
            <Button
              style={{ marginTop: 20, marginBottom: -20 }}
              onClick={this.resetToDefault}
              color="primary"
            >
              <Trans i18nKey="theme_reset_to_default" />
            </Button>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.onClose} color="primary">
              <Trans i18nKey="global_cancel" />
            </Button>
            <Button onClick={this.submitDialog} color="primary">
              <Trans i18nKey="global_save" />
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  resetToDefault = () => {
    let theme = createMuiTheme();
    this.setState({
      primaryColour: theme.palette.primary.main,
      accentColour: theme.palette.secondary.main,
    });
  };

  submitDialog = () => {
    this.props.onSubmit(this.state.primaryColour, this.state.accentColour);
  };

  primaryColourSelected = (colour) => {
    this.setState({ primaryColour: colour.hex });
  };

  accentColourSelected = (colour) => {
    this.setState({ accentColour: colour.hex });
  };
}

const mapStateToProps = (state) => ({
  theme: state.theme.userTheme,
});

export default connect(
  mapStateToProps,
  null
)(ColourPickerDialog);
